module.exports = __webpack_public_path__ + "static/media/Plane-Card.4f38f27f.jpg";